import { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

const CHATVOLT_AGENT_ID = "cmbtc43oh004uqso0xff9958b";
const CHATVOLT_SCRIPT_ID = "chatvolt-support-loader";
const CHATVOLT_BUBBLE_TAG = "chatvolt-chatbox-bubble";

const getNameParts = (nome = "") => {
    const parts = nome.trim().split(/\s+/).filter(Boolean);

    if (!parts.length) {
        return {};
    }

    return {
        firstName: parts[0],
        lastName: parts.length > 1 ? parts.slice(1).join(" ") : undefined,
    };
};

const removeEmptyFields = (data) =>
    Object.keys(data).reduce((acc, key) => {
        if (data[key]) {
            acc[key] = data[key];
        }

        return acc;
    }, {});

class ChatvoltSupport extends Component {
    componentDidMount() {
        this.mounted = true;
        this.syncChatvolt();
    }

    componentDidUpdate(prevProps) {
        const previousKey = this.getWidgetKey(prevProps);
        const currentKey = this.getWidgetKey(this.props);

        if (previousKey !== currentKey) {
            this.destroyWidget();
            this.syncChatvolt();
        }
    }

    componentWillUnmount() {
        this.mounted = false;
        this.destroyWidget();
    }

    getContact(props = this.props) {
        const user = props.usuarioLogado || {};
        const authUser = props.authUser || {};

        return removeEmptyFields({
            ...getNameParts(user.nome),
            email: user.email,
            userId: String(authUser.sub || ""),
        });
    }

    getWidgetKey(props = this.props) {
        if (!props.isAuthenticated) {
            return "";
        }

        const contact = this.getContact(props);

        if (!Object.keys(contact).length) {
            return "";
        }

        return JSON.stringify({
            agentId: CHATVOLT_AGENT_ID,
            contact,
        });
    }

    syncChatvolt() {
        const key = this.getWidgetKey();

        if (!key || typeof window === "undefined") {
            return;
        }

        const config = JSON.parse(key);
        
        const initialize = (Chatbox) => {
            if (!this.mounted || this.getWidgetKey() !== key) {
                return;
            }

            Chatbox.initBubble(config);
        };

        if (window.ChatvoltChatbox) {
            initialize(window.ChatvoltChatbox);

            return;
        }

        window.__initChatvoltSupport = (Chatbox) => {
            window.ChatvoltChatbox = Chatbox;

            initialize(Chatbox);
        };

        if (document.getElementById(CHATVOLT_SCRIPT_ID)) {
            return;
        }

        const script = document.createElement("script");
        script.id = CHATVOLT_SCRIPT_ID;
        script.type = "module";
        script.textContent = `
            import Chatbox from 'https://cdn.jsdelivr.net/npm/@chatvolt/embeds@latest/dist/chatbox/index.js';
            window.__initChatvoltSupport && window.__initChatvoltSupport(Chatbox);
        `;
        
        document.body.appendChild(script);
    }

    destroyWidget() {
        if (typeof window === "undefined") {
            return;
        }

        if (window.ChatboxBubble && typeof window.ChatboxBubble.destroy === "function") {
            window.ChatboxBubble.destroy();
        }

        Array.from(document.querySelectorAll(CHATVOLT_BUBBLE_TAG)).forEach((element) => {
            if (typeof element.destroy === "function") {
                element.destroy();
            }

            element.remove();
        });

        window.ChatboxBubble = null;
        window.ChatBoxBubble = null;
    }

    render() {
        return null;
    }
}

ChatvoltSupport.propTypes = {
    isAuthenticated: PropTypes.bool.isRequired,
    authUser: PropTypes.object.isRequired,
    usuarioLogado: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
    authUser: state.auth.user,
    usuarioLogado: state.usuarioLogado.dados,
});

export default connect(mapStateToProps)(ChatvoltSupport);
